// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ff238746","298":"b0fef518","453":"c72295f3","888":"f0340733"}[chunkId] + ".chunk.js";
};